import {
  GET_WAREHOUSE_REQUEST,
  GET_WAREHOUSE_SUCCESS,
  GET_WAREHOUSE_FAILURE,
  GET_YARDOCCUPANCY_REQUEST,
  GET_YARDOCCUPANCY_SUCCESS,
  GET_YARDOCCUPANCY_FAILURE,
  GET_INVENTORY_REQUEST,
  GET_INVENTORY_SUCCESS,
  GET_INVENTORY_FAILURE,
  GET_PICKUP_REQUEST,
  GET_PICKUP_SUCCESS,
  GET_PICKUP_FAILURE,
  GET_FINISHEDGOODSHP_REQUEST,
  GET_FINISHEDGOODSHP_SUCCESS,
  GET_FINISHEDGOODSHP_FAILURE,
  GET_PDI_REQUEST,
  GET_PDI_SUCCESS,
  GET_PDI_FAILURE,
  GET_REJECTION_REQUEST,
  GET_REJECTION_SUCCESS,
  GET_REJECTION_FAILURE,
  GET_NAVBAR_BOXES_REQUEST,
  GET_NAVBAR_BOXES_SUCCESS,
  GET_NAVBAR_BOXES_FAILURE,
  GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_REQUEST,
  GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_SUCCESS,
  GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_FAILURE,
  GET_GRN_REPORT_HOME_REQUEST,
  GET_GRN_REPORT_HOME_SUCCESS,
  GET_GRN_REPORT_HOME_FAILURE,
  GET_FG_REPORT_HOME_REQUEST,
  GET_FG_REPORT_HOME_SUCCESS,
  GET_FG_REPORT_HOME_FAILURE,
  GET_ITEM_STATUS_REPORT_HOME_REQUEST,
  GET_ITEM_STATUS_REPORT_HOME_SUCCESS,
  GET_ITEM_STATUS_REPORT_HOME_FAILURE,
  GET_INVENTORY_AGEING_REPORT_HOME_REQUEST,
  GET_INVENTORY_AGEING_REPORT_HOME_SUCCESS,
  GET_INVENTORY_AGEING_REPORT_HOME_FAILURE,
  GET_PICKLIST_AGEING_REPORT_HOME_REQUEST,
  GET_PICKLIST_AGEING_REPORT_HOME_SUCCESS,
  GET_PICKLIST_AGEING_REPORT_HOME_FAILURE,
  GET_TOP10_REPORT_HOME_REQUEST,
  GET_TOP10_REPORT_HOME_SUCCESS,
  GET_TOP10_REPORT_HOME_FAILURE,
  GET_EFFICIENCY_REPORT_HOME_REQUEST,
  GET_EFFICIENCY_REPORT_HOME_SUCCESS,
  GET_EFFICIENCY_REPORT_HOME_FAILURE,
  GET_VENDOR_COUNT_REQUEST,
  GET_VENDOR_COUNT_SUCCESS,
  GET_VENDOR_COUNT_FAILURE,
  GET_WAREHOUSE_ZONES_REQUEST,
  GET_WAREHOUSE_ZONES_SUCCESS,
  GET_WAREHOUSE_ZONES_FAILURE,
  GET_WAREHOUSE_CARD_DATA_SUCCESS,
  GET_WAREHOUSE_CARD_DATA_FAILURE,
  GET_WAREHOUSE_CARD_DATA_REQUEST,
  GET_EXPANDED_GRN_REPORT_HOME_REQUEST,
  GET_EXPANDED_GRN_REPORT_HOME_SUCCESS,
  GET_EXPANDED_GRN_REPORT_HOME_FAILURE,
  GET_EXPANDED_FG_REPORT_HOME_REQUEST,
  GET_EXPANDED_FG_REPORT_HOME_SUCCESS,
  GET_EXPANDED_FG_REPORT_HOME_FAILURE,
  GET_EXPANDED_INVENTORY_REPORT_HOME_REQUEST,
  GET_EXPANDED_INVENTORY_REPORT_HOME_SUCCESS,
  GET_EXPANDED_INVENTORY_REPORT_HOME_FAILURE,
  GET_EXPANDED_PICKLIST_REPORT_HOME_REQUEST,
  GET_EXPANDED_PICKLIST_REPORT_HOME_SUCCESS,
  GET_EXPANDED_PICKLIST_REPORT_HOME_FAILURE,
  GET_VENDOR_APPLICATION_REQUEST,
  GET_VENDOR_APPLICATION_SUCCESS,
  GET_VENDOR_APPLICATION_FAILURE,
  GET_VENDOR_MONTHLY_REQUEST,
  GET_VENDOR_MONTHLY_SUCCESS,
  GET_VENDOR_MONTHLY_FAILURE,
  GET_VENDOR_SUBSCRIPTION_COUNT_REQUEST,
  GET_VENDOR_SUBSCRIPTION_COUNT_SUCCESS,
  GET_VENDOR_SUBSCRIPTION_COUNT_FAILURE,
} from "./homeTypes";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;

const getWarehouseRequest = () => {
  return {
    type: GET_WAREHOUSE_REQUEST,
  };
};

const getWarehouseSuccess = (payload) => {
  return {
    type: GET_WAREHOUSE_SUCCESS,
    payload: payload,
  };
};

const getWarehouseFailure = (error) => {
  return {
    type: GET_WAREHOUSE_FAILURE,
    payload: error,
  };
};

const getWarehouse = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehouseRequest());
    let url = `${baseUrl}/homepage/warehouses?warehouse_id=${id}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWarehouseSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehouseFailure(err.message));
      });
  };
};

const getYardOccupancyRequest = () => {
  return {
    type: GET_YARDOCCUPANCY_REQUEST,
  };
};

const getYardOccupancySuccess = (payload) => {
  return {
    type: GET_YARDOCCUPANCY_SUCCESS,
    payload: payload,
  };
};

const getYardOccupancyFailure = (error) => {
  return {
    type: GET_YARDOCCUPANCY_FAILURE,
    payload: error,
  };
};

const getYard = (id) => {
  return (dispatch) => {
    dispatch(getYardOccupancyRequest());
    let url = `${baseUrl}/homepage/yard_occupancy?warehouse_id=${id}`;
    axios
      .get(url)
      .then((response) => {
        dispatch(getYardOccupancySuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getYardOccupancyFailure(err.message));
      });
  };
};

const getInventoryRequest = () => {
  return {
    type: GET_INVENTORY_REQUEST,
  };
};

const getInventorySuccess = (payload) => {
  return {
    type: GET_INVENTORY_SUCCESS,
    payload: payload,
  };
};

const getInventoryFailure = (error) => {
  return {
    type: GET_INVENTORY_FAILURE,
    payload: error,
  };
};

const getInventory = () => {
  return (dispatch) => {
    dispatch(getInventoryRequest());
    let url = `${baseUrl}/homepage/inventory`;
    axios
      .get(url)
      .then((response) => {
        dispatch(getInventorySuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getInventoryFailure(err.message));
      });
  };
};

const getPickupRequest = () => {
  return {
    type: GET_PICKUP_REQUEST,
  };
};

const getPickupSuccess = (payload) => {
  return {
    type: GET_PICKUP_SUCCESS,
    payload: payload,
  };
};

const getPickupFailure = (error) => {
  return {
    type: GET_PICKUP_FAILURE,
    payload: error,
  };
};

const getPickup = () => {
  return (dispatch) => {
    dispatch(getPickupRequest());
    let url = `${baseUrl}/homepage/pickup_list_status`;
    axios
      .get(url)
      .then((response) => {
        dispatch(getPickupSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getPickupFailure(err.message));
      });
  };
};

const getFinishedGoodsRequest = () => {
  return {
    type: GET_FINISHEDGOODSHP_REQUEST,
  };
};

const getFinishedGoodsSuccess = (payload) => {
  return {
    type: GET_FINISHEDGOODSHP_SUCCESS,
    payload: payload,
  };
};

const getFinishedGoodsFailure = (error) => {
  return {
    type: GET_FINISHEDGOODSHP_FAILURE,
    payload: error,
  };
};

const getFg = () => {
  return (dispatch) => {
    dispatch(getFinishedGoodsRequest());
    let url = `${baseUrl}/homepage/fg_status`;
    axios
      .get(url)
      .then((response) => {
        dispatch(getFinishedGoodsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getFinishedGoodsFailure(err.message));
      });
  };
};

const getPdiRequest = () => {
  return {
    type: GET_PDI_REQUEST,
  };
};

const getPdiSuccess = (payload) => {
  return {
    type: GET_PDI_SUCCESS,
    payload: payload,
  };
};

const getPdiFailure = (error) => {
  return {
    type: GET_PDI_FAILURE,
    payload: error,
  };
};

const getPdi = () => {
  return (dispatch) => {
    dispatch(getPdiRequest());
    let url = `${baseUrl}/homepage/dispatch_status`;
    axios
      .get(url)
      .then((response) => {
        dispatch(getPdiSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getPdiFailure(err.message));
      });
  };
};

const getRejectionRequest = () => {
  return {
    type: GET_REJECTION_REQUEST,
  };
};

const getRejectionSuccess = (payload) => {
  return {
    type: GET_REJECTION_SUCCESS,
    payload: payload,
  };
};

const getRejectionFailure = (error) => {
  return {
    type: GET_REJECTION_FAILURE,
    payload: error,
  };
};

const getRejection = () => {
  return (dispatch) => {
    dispatch(getRejectionRequest());
    let url = `${baseUrl}/homepage/rejection_status`;
    axios
      .get(url)
      .then((response) => {
        dispatch(getRejectionSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getRejectionFailure(err.message));
      });
  };
};

const getNavbarBoxesRequest = () => {
  return {
    type: GET_NAVBAR_BOXES_REQUEST,
  };
};

const getNavbarBoxesSuccess = (payload) => {
  return {
    type: GET_NAVBAR_BOXES_SUCCESS,
    payload: payload,
  };
};

const getNavbarBoxesFailure = (error) => {
  return {
    type: GET_NAVBAR_BOXES_FAILURE,
    payload: error,
  };
};

const getNavbarBoxes = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getNavbarBoxesRequest());
    // let url = `${baseUrl}/navbarBoxes`;
    let url = `${baseUrlReport}/navbar_box`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getNavbarBoxesSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getNavbarBoxesFailure(err.message));
      });
  };
};

const getWarehouseOccupancyReportHomeRequest = () => {
  return {
    type: GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_REQUEST,
  };
};

const getWarehouseOccupancyReportHomeSuccess = (payload) => {
  return {
    type: GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getWarehouseOccupancyReportHomeFailure = (error) => {
  return {
    type: GET_WAREHOUSE_OCCUPANCY_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getWarehouseOccupancyReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehouseOccupancyReportHomeRequest());

    // let url = `${baseUrl}/occupancy`;
    let url = `${baseUrlReport}/occupancy`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWarehouseOccupancyReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehouseOccupancyReportHomeFailure(err.message));
      });
  };
};

const getVendorForMonthlyRequest = () => {
  return {
    type: GET_VENDOR_MONTHLY_REQUEST,
  };
};

const getVendorForMonthlySuccess = (payload) => {
  return {
    type: GET_VENDOR_MONTHLY_SUCCESS,
    payload: payload,
  };
};

const getVendorForMonthlyFailure = (error) => {
  return {
    type: GET_VENDOR_MONTHLY_FAILURE,
    payload: error,
  };
};

const getVendorForMonthly = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorForMonthlyRequest());
    let url = `${baseUrl}/vendor/monthly_vendor_trend`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVendorForMonthlySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorForMonthlyFailure(err.message));
      });
  };
};

const getVendorSubscriptionCountRequest = () => {
  return {
    type: GET_VENDOR_SUBSCRIPTION_COUNT_REQUEST,
  };
};

const getVendorSubscriptionCountSuccess = (payload) => {
  return {
    type: GET_VENDOR_SUBSCRIPTION_COUNT_SUCCESS,
    payload: payload,
  };
};

const getVendorSubscriptionCountFailure = (error) => {
  return {
    type: GET_VENDOR_SUBSCRIPTION_COUNT_FAILURE,
    payload: error,
  };
};

const getVendorSubscriptionCount = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorSubscriptionCountRequest());
    let url = `${baseUrl}/vendor/vendor_usage`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response);
        dispatch(getVendorSubscriptionCountSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorSubscriptionCountFailure(err.message));
      });
  };
};

const getGrnReportHomeRequest = () => {
  return {
    type: GET_GRN_REPORT_HOME_REQUEST,
  };
};

const getGrnReportHomeSuccess = (payload) => {
  return {
    type: GET_GRN_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getGrnReportHomeFailure = (error) => {
  return {
    type: GET_GRN_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getGrnReportHome = (startDate, endDate, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getGrnReportHomeRequest());
    // let url = `${baseUrlReport}/report_api/grn/daywise_grn?from=${startDate}&to=${endDate}`;
    let url = `${baseUrlReport}/grn/daywise_grn?from=${startDate}&to=${endDate}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getGrnReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getGrnReportHomeFailure(err.message));
      });
  };
};

const getFgReportHomeRequest = () => {
  return {
    type: GET_FG_REPORT_HOME_REQUEST,
  };
};

const getFgReportHomeSuccess = (payload) => {
  return {
    type: GET_FG_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getFgReportHomeFailure = (error) => {
  return {
    type: GET_FG_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getFgReportHome = (startDate, endDate, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getFgReportHomeRequest());
    // let url = `${baseUrl}/fg_dispatch?from=${startDate}&to=${endDate}`;
    let url = `${baseUrlReport}swms/reports/fg/daywise_fg?from=${startDate}&to=${endDate}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getFgReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getFgReportHomeFailure(err.message));
      });
  };
};

const getItemStatusReportHomeRequest = () => {
  return {
    type: GET_ITEM_STATUS_REPORT_HOME_REQUEST,
  };
};

const getItemStatusReportHomeSuccess = (payload) => {
  return {
    type: GET_ITEM_STATUS_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getItemStatusReportHomeFailure = (error) => {
  return {
    type: GET_ITEM_STATUS_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getItemStatusReportHome = (startDate, endDate, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getItemStatusReportHomeRequest());
    let url = `${baseUrlReport}/item/item_status?from=${startDate}&to=${endDate}`;
    // let url = `${baseUrl}swms/reports/item?from=${startDate}&to=${endDate}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getItemStatusReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getItemStatusReportHomeFailure(err.message));
      });
  };
};

const getInventoryAgeingReportHomeRequest = () => {
  return {
    type: GET_INVENTORY_AGEING_REPORT_HOME_REQUEST,
  };
};

const getInventoryAgeingReportHomeSuccess = (payload) => {
  return {
    type: GET_INVENTORY_AGEING_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getInventoryAgeingReportHomeFailure = (error) => {
  return {
    type: GET_INVENTORY_AGEING_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getInventoryAgeingReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getInventoryAgeingReportHomeRequest());
    // let url = `${baseUrl}/inventory_aging`;
    let url = `${baseUrlReport}/inventory/inventory_aging`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getInventoryAgeingReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getInventoryAgeingReportHomeFailure(err.message));
      });
  };
};

const getPicklistAgeingReportHomeRequest = () => {
  return {
    type: GET_PICKLIST_AGEING_REPORT_HOME_REQUEST,
  };
};

const getPicklistAgeingReportHomeSuccess = (payload) => {
  return {
    type: GET_PICKLIST_AGEING_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getPicklistAgeingReportHomeFailure = (error) => {
  return {
    type: GET_PICKLIST_AGEING_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getPicklistAgeingReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPicklistAgeingReportHomeRequest());
    // let url = `${baseUrl}/picklist_aging`;
    let url = `${baseUrlReport}/picklist/picklist_aging`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPicklistAgeingReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPicklistAgeingReportHomeFailure(err.message));
      });
  };
};

const getTop10ReportHomeRequest = () => {
  return {
    type: GET_TOP10_REPORT_HOME_REQUEST,
  };
};

const getTop10ReportHomeSuccess = (payload) => {
  return {
    type: GET_TOP10_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getTop10ReportHomeFailure = (error) => {
  return {
    type: GET_TOP10_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getTop10ReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getTop10ReportHomeRequest());
    // let url = `${baseUrl}/top_items`;
    let url = `${baseUrlReport}/inventory/top_items`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTop10ReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTop10ReportHomeFailure(err.message));
      });
  };
};

const getVendorApplicationRequest = () => {
  return {
    type: GET_VENDOR_APPLICATION_REQUEST,
  };
};

const getVendorApplicationSuccess = (payload) => {
  return {
    type: GET_VENDOR_APPLICATION_SUCCESS,
    payload: payload,
  };
};

const getVendorApplicationFailure = (error) => {
  return {
    type: GET_VENDOR_APPLICATION_FAILURE,
    payload: error,
  };
};

const getVendorApplication = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorApplicationRequest());
    // let url = `${baseUrl}/top_items`;
    let url = `${baseUrl}/vendor/recent_vendors`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVendorApplicationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorApplicationFailure(err.message));
      });
  };
};

const getWarehouseEfficiencyReportHomeRequest = () => {
  return {
    type: GET_EFFICIENCY_REPORT_HOME_REQUEST,
  };
};

const getWarehouseEfficiencyReportHomeSuccess = (payload) => {
  return {
    type: GET_EFFICIENCY_REPORT_HOME_SUCCESS,
    payload: payload,
  };
};

const getWarehouseEfficiencyReportHomeFailure = (error) => {
  return {
    type: GET_EFFICIENCY_REPORT_HOME_FAILURE,
    payload: error,
  };
};

const getWarehouseEfficiencyReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehouseEfficiencyReportHomeRequest());
    let url = `${baseUrlReport}/dashboard_warehouse_efficiency`;
    // let url = `${baseUrlReport}/report_api/dashboard_warehouse_efficiency`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getWarehouseEfficiencyReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehouseEfficiencyReportHomeFailure(err.message));
      });
  };
};

const getVendorStatusCountsRequest = () => {
  return {
    type: GET_VENDOR_COUNT_REQUEST,
  };
};

const getVendorStatusCountsSuccess = (payload) => {
  return {
    type: GET_VENDOR_COUNT_SUCCESS,
    payload: payload,
  };
};

const getVendorStatusCountsFailure = (error) => {
  return {
    type: GET_VENDOR_COUNT_FAILURE,
    payload: error,
  };
};

const getVendorStatusCounts = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getVendorStatusCountsRequest());
    let url = `${baseUrl}/vendor/get_vendor_count`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getVendorStatusCountsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getVendorStatusCountsFailure(err.message));
      });
  };
};

const getWarehouseOccupancyCardDataRequest = () => {
  return {
    type: GET_WAREHOUSE_CARD_DATA_REQUEST,
  };
};

const getWarehouseOccupancyCardDataSuccess = (payload) => {
  return {
    type: GET_WAREHOUSE_CARD_DATA_SUCCESS,
    payload: payload,
  };
};

const getWarehouseOccupancyCardDataFailure = (error) => {
  return {
    type: GET_WAREHOUSE_CARD_DATA_FAILURE,
    payload: error,
  };
};

const getWarehouseOccupancyCardData = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehouseOccupancyCardDataRequest());
    // let url = `${baseUrl}/dashboard_warehouse_occupancy/get_by_type`;
    let url = `${baseUrlReport}/dashboard_warehouse_occupancy/get_by_type`;
    axios
      .get(url, headers)
      .then((response) => {
        console.log("responsez", response);
        dispatch(getWarehouseOccupancyCardDataSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehouseOccupancyCardDataFailure(err.message));
      });
  };
};

const getWarehouseZonesReportHomeRequest = () => {
  return {
    type: GET_WAREHOUSE_ZONES_REQUEST,
  };
};

const getWarehouseZonesReportHomeSuccess = (payload) => {
  return {
    type: GET_WAREHOUSE_ZONES_SUCCESS,
    payload: payload,
  };
};

const getWarehouseZonesReportHomeFailure = (error) => {
  return {
    type: GET_WAREHOUSE_ZONES_FAILURE,
    payload: error,
  };
};

const getWarehouseZonesReportHome = (id, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getWarehouseZonesReportHomeRequest());
    let url = `${baseUrlReport}/dashboard_warehouse_occupancy/get_by_id?id=${id}`;
    axios
      .get(url, headers)
      .then((response) => {
        // console.log("responseFirAPI", response);
        dispatch(getWarehouseZonesReportHomeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getWarehouseZonesReportHomeFailure(err.message));
      });
  };
};
const getExpandedFgReportHomeRequest = () => ({
  type: GET_EXPANDED_FG_REPORT_HOME_REQUEST,
});
const getExpandedFgReportHomeSuccess = (payload) => ({
  type: GET_EXPANDED_FG_REPORT_HOME_SUCCESS,
  payload,
});
const getExpandedFgReportHomeFailure = (error) => ({
  type: GET_EXPANDED_FG_REPORT_HOME_FAILURE,
  payload: error,
});
const getExpandedFgReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getExpandedFgReportHomeRequest());

    // let url = `${baseUrlReport}/report_api/fg/expanded_fg`;
    let url = `${baseUrlReport}/fg/expanded_fg`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getExpandedFgReportHomeSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getExpandedFgReportHomeFailure(error.message));
      });
  };
};
const getExpandedGrnReportHomeRequest = () => ({
  type: GET_EXPANDED_GRN_REPORT_HOME_REQUEST,
});
const getExpandedGrnReportHomeSuccess = (payload) => ({
  type: GET_EXPANDED_GRN_REPORT_HOME_SUCCESS,
  payload,
});

const getExpandedGrnReportHomeFailure = (error) => ({
  type: GET_EXPANDED_GRN_REPORT_HOME_FAILURE,
  payload: error,
});
const getExpandedGrnReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getExpandedGrnReportHomeRequest());

    let url = `${baseUrlReport}/grn/expanded_grn`;
    // let url = `${baseUrlReport}/report_api/grn/expanded_grn`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getExpandedGrnReportHomeSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getExpandedGrnReportHomeFailure(error.message));
      });
  };
};

const getExpandedInventoryReportHomeRequest = () => ({
  type: GET_EXPANDED_INVENTORY_REPORT_HOME_REQUEST,
});

const getExpandedInventoryReportHomeSuccess = (payload) => ({
  type: GET_EXPANDED_INVENTORY_REPORT_HOME_SUCCESS,
  payload,
});

const getExpandedInventoryReportHomeFailure = (error) => ({
  type: GET_EXPANDED_INVENTORY_REPORT_HOME_FAILURE,
  payload: error,
});

const getExpandedInventoryReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getExpandedInventoryReportHomeRequest());

    // let url = `${baseUrl}/expended_inventory`;
    // let url = `${baseUrlReport}/report_api/inventory/expended_inventory?page_number=1&rows_per_page=10&search=&download=0`;
    let url = `${baseUrlReport}/inventory/expended_inventory?page_number=1&rows_per_page=1`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getExpandedInventoryReportHomeSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getExpandedInventoryReportHomeFailure(error.message));
      });
  };
};

const getExpandedPicklistReportHomeRequest = () => ({
  type: GET_EXPANDED_PICKLIST_REPORT_HOME_REQUEST,
});

const getExpandedPicklistReportHomeSuccess = (payload) => ({
  type: GET_EXPANDED_PICKLIST_REPORT_HOME_SUCCESS,
  payload,
});

const getExpandedPicklistReportHomeFailure = (error) => ({
  type: GET_EXPANDED_PICKLIST_REPORT_HOME_FAILURE,
  payload: error,
});

const getExpandedPicklistReportHome = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  let url = `${baseUrlReport}/picklist/expended_picklist?page_number=1&rows_per_page=10`;
  // let url = `${baseUrl}/expended_picklist?page_number=1&rows_per_page=10&search={ "picklistCode": "P-WO"}&download=0&itemCode=`;

  return (dispatch) => {
    dispatch(getExpandedPicklistReportHomeRequest());

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getExpandedPicklistReportHomeSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getExpandedPicklistReportHomeFailure(error.message));
      });
  };
};

export {
  getWarehouse,
  getYard,
  getInventory,
  getPickup,
  getFg,
  getPdi,
  getRejection,
  getNavbarBoxes,
  getWarehouseOccupancyReportHome,
  getGrnReportHome,
  getFgReportHome,
  getItemStatusReportHome,
  getTop10ReportHome,
  getInventoryAgeingReportHome,
  getPicklistAgeingReportHome,
  getWarehouseEfficiencyReportHome,
  getVendorStatusCounts,
  getWarehouseOccupancyCardData,
  getWarehouseZonesReportHome,
  getExpandedFgReportHome,
  getExpandedGrnReportHome,
  getExpandedGrnReportHomeFailure,
  getExpandedInventoryReportHome,
  getExpandedPicklistReportHome,
  getVendorApplication,
  getVendorForMonthly,
  getVendorSubscriptionCount,
};
